<template>
  <v-app id="copyHuis2">
    <v-main>
      <v-container fluid>
      <v-row>
          <v-col cols="4">
            <v-text-field v-model="huis_code_from" label="From Acco ID"></v-text-field>
          </v-col>
          <v-col cols="4">
            <v-text-field v-model="huis_code_to" label="To Acco ID"></v-text-field>
          </v-col>
      </v-row>

      <v-row>
          <v-col cols="4">
             <v-checkbox v-model="copy_gplc" label="Copy Google Address and GPS coordinates"></v-checkbox>
          </v-col>
      </v-row>
      <!--
      <v-row>
          <v-col cols="4">
             <v-checkbox v-model="copy_hsft" label="Copy Photos"></v-checkbox>
          </v-col>
      </v-row>
      -->
      <v-row>
          <v-col cols="4">
             <v-checkbox v-model="copy_hsii" label="Copy Layout"></v-checkbox>
          </v-col>
      </v-row>
      <v-row>
          <v-col cols="4">
             <v-checkbox v-model="copy_txts" label="Copy Description"></v-checkbox>
          </v-col>
      </v-row>
      <v-row>
          <v-col cols="4">
             <v-checkbox v-model="copy_hsne" label="Copy Properties"></v-checkbox>
          </v-col>
      </v-row>  
      <v-row>
          <v-col cols="4">
             <v-checkbox v-model="copy_hszn" label="Copy Acco sentences"></v-checkbox>
          </v-col>
      </v-row>
      <v-row>
          <v-col cols="4">
             <v-checkbox v-model="copy_hsab" label="Copy Discounts"></v-checkbox>
          </v-col>
      </v-row>        

      <v-row>    
          <v-col cols="4">
            <v-btn class="primary ma-0" small @click="copyAcco" :disabled="submitted">Copy</v-btn>
          </v-col> 
      </v-row>

    </v-container>
    </v-main>
    <navBar title="Ares - Main menu" :home="true" :accolist="false" type="main"/>
  </v-app>
</template>

<script>
 import navBar from "@/components/ui/navbars/navbar.vue";
 export default {
  components: {
    navBar
  },
  data() {
    return {
      huis_code_from: '',
      huis_code_to: '',
      copy_gplc: false,
      copy_hsft: false,
      copy_hsii: false,
      copy_txts: false,
      copy_hszn: false,
      copy_hsab: false,
      copy_hsne: false,
      param: {},
      submitted: false
    }
  },
  methods: {
     copyAcco() {
      this.submitted = true;
      this.$axios
        .post("ares/json/ares/huis/copyHuis2.p", {
          header: {
            token: this.$session.get("ARES"),
            clientSessionId: this.$session.id(),
            request: "copyHuis2"
          },
          copyHuis2: {
            huis_code_from: this.huis_code_from,
            huis_code_to: this.huis_code_to,
            copy_hsft: this.copy_hsft,
            copy_hsii: this.copy_hsii,
            copy_txts: this.copy_txts,
            copy_hszn: this.copy_hszn,
            copy_gplc: this.copy_gplc,
            copy_hsab: this.copy_hsab,
            copy_hsne: this.copy_hsne
          }
        })
        .then(res => {
          if (res.data.error) {
            console.log(res.data.error);
          } else {
            this.submitted = false;
            this.items = res.data.copyHuis2;
            
                 this.$store.dispatch('setSnackbar', {
                  showing: true,
                  text: res.data.text,
                  color: res.data.color
                 });
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },

  }
};

</script> 
